import { useEffect } from "react";

// Metronic 전역 CSS(html{font-size:12~13px!important})가 rem 기반 Tailwind 크기를 축소시켜
// shadcn 페이지에 머무는 동안만 16px(브라우저 기본값)로 되돌린다. important 플래그 없이는
// 기존 !important 규칙을 이길 수 없다.
// 로그인 계열 shadcn 페이지들이 공유하는 wrapper. 레이아웃 리뉴얼 시 이 파일 하나만 교체하면 된다.
export default function ShadcnPageWrapper({ children }) {
  useEffect(() => {
    document.documentElement.style.setProperty("font-size", "16px", "important");
    return () => {
      document.documentElement.style.removeProperty("font-size");
    };
  }, []);

  return children;
}
